import { useEffect } from 'react';
import { useToggleState } from 'app/lib/hooks/useToggleState/useToggleState.js';

export function useIsStickyElementPinned(ref, enabled = true) {
    const [isPinned, toggleIsPinned] = useToggleState(false);

    useEffect(() => {
        const element = ref.current;
        if (enabled && element) {
            const observer = new IntersectionObserver(
                ([e]) => toggleIsPinned(e.intersectionRatio < 1),
                { threshold: [1] }
            );

            observer.observe(element);
            return () => observer.unobserve(element);
        }
    }, [enabled, ref, toggleIsPinned]);

    return isPinned;
}
